import { applyAtPrefix } from '../../utils/stringUtils.js';
import { geolocDeniedMessage } from '../../services/geolocationService.js';

export function createMapPhotoUploadFeature({
  geolocationService,
  uploadMapPhoto,
  onUploadSuccess,
}) {
  const uploadBtn    = document.getElementById('map-photo-upload-btn');
  const modal        = document.getElementById('map-photo-modal');
  const modalClose   = document.getElementById('map-photo-modal-close');
  const form         = document.getElementById('map-photo-form');
  const fileInput    = document.getElementById('map-photo-file');
  const previewImg   = document.getElementById('map-photo-preview-img');
  const pseudoInput  = document.getElementById('map-photo-pseudo');
  const geolocToggle = document.getElementById('map-photo-geoloc-toggle');
  const geolocLabel  = document.getElementById('map-photo-geoloc-label');
  const geolocStatus = document.getElementById('map-photo-geoloc-status');
  const submitBtn    = document.getElementById('map-photo-submit-btn');
  const submitStatus = document.getElementById('map-photo-submit-status');

  let currentCoords = null;
  let currentPreviewUrl = '';

  function revokePreviewUrl() {
    if (currentPreviewUrl) URL.revokeObjectURL(currentPreviewUrl);
    currentPreviewUrl = '';
  }

  function open() {
    currentCoords        = null;
    fileInput.value      = '';
    revokePreviewUrl();
    previewImg.src       = '';
    previewImg.hidden    = true;
    pseudoInput.value    = '';
    geolocToggle.checked = false;
    geolocLabel.classList.remove('geoloc-label-text--error');
    geolocStatus.textContent = '';
    submitStatus.textContent = '';
    submitBtn.disabled       = false;
    modal.hidden             = false;
    document.body.classList.add('map-photo-modal-open');
  }

  function close() {
    revokePreviewUrl();
    modal.hidden = true;
    document.body.classList.remove('map-photo-modal-open');
  }

  uploadBtn?.addEventListener('click', open);
  modalClose?.addEventListener('click', close);
  modal?.addEventListener('click', (e) => { if (e.target === modal) close(); });

  pseudoInput?.addEventListener('focus', () => {
    document.body.style.position = 'fixed';
    document.body.style.width    = '100%';
  });
  pseudoInput?.addEventListener('blur', () => {
    document.body.style.position = '';
    document.body.style.width    = '';
  });

  geolocToggle?.addEventListener('change', () => {
    geolocLabel.classList.remove('geoloc-label-text--error');
    if (!geolocToggle.checked) {
      currentCoords            = null;
      geolocStatus.textContent = '';
      return;
    }
    geolocStatus.textContent = 'Récupération de la position…';
    geolocationService.getCurrentPosition()
      .then((pos) => {
        currentCoords            = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        geolocStatus.textContent = 'Position partagée ✓';
      })
      .catch((err) => {
        console.warn('[geoloc] Échec de la géolocalisation (map photo):', err?.message ?? err);
        currentCoords            = null;
        geolocToggle.checked     = false;
        geolocStatus.textContent = err?.code === 1
          ? `${geolocDeniedMessage()}.`
          : 'Position non disponible — désactive ton VPN si actif.';
      });
  });

  fileInput?.addEventListener('change', () => {
    revokePreviewUrl();
    const file = fileInput.files[0];
    if (!file) { previewImg.src = ''; previewImg.hidden = true; return; }
    currentPreviewUrl  = URL.createObjectURL(file);
    previewImg.src     = currentPreviewUrl;
    previewImg.hidden  = false;
  });

  pseudoInput?.addEventListener('input', () => applyAtPrefix(pseudoInput));

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!geolocToggle.checked || !currentCoords) {
      geolocLabel.classList.add('geoloc-label-text--error');
      if (!geolocToggle.checked) geolocStatus.textContent = '';
      return;
    }
    const file = fileInput.files[0];
    if (!file) { submitStatus.textContent = 'Choisir une photo.'; return; }
    submitBtn.disabled       = true;
    submitStatus.textContent = 'Envoi en cours…';
    try {
      const fd = new FormData();
      fd.append('photo',  file);
      fd.append('pseudo', pseudoInput.value.trim());
      fd.append('lat',    String(currentCoords.lat));
      fd.append('lng',    String(currentCoords.lng));
      await uploadMapPhoto(fd);
      close();
      await onUploadSuccess();
    } catch (err) {
      submitStatus.textContent = 'Erreur : ' + err.message;
      submitBtn.disabled       = false;
    }
  });

  return { open, close };
}
